import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal as RBModal } from "react-bootstrap";
import moment from "moment";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  Select,
  DatePicker,
  Input,
  Modal,
  Icon
} from "../../components";
import { axios, Constants, Globals, ENV } from "../../utils";
import PrinterIcon from '../../assets/icons/printer.png';
import ModalCreatePayment from "./modal-create-payment";
import AddIcon from '../../assets/icons/add.png';
import CloseIcon from "../../assets/icons/icono_cerrar.png";
import FilterIcon from "../../assets/icons/icono_filtro.png";
import TabCommissionIcon from "../../assets/icons/tab-commissions.png";
import TabCommissionPaymentsIcon from "../../assets/icons/tab-commission-payments.png";

class Commisions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleAddPayment: false,
      showFilters: false,
      total: 0,
      header: [
        'Fecha de Pedido',
        'N° Pedido',
        'Vendedor',
        'Gerente',
        'Cliente',
        'Monto Total Venta',
        'Monto Abonado Venta',
        'Comisión por Pagar (Vendedor)',
        'Comisión Pagada (Vendedor)',
        'Comisión por Pagar (Gerente)',
        'Comisión Pagada (Gerente)',
        ''
      ],
      page: 1,
      last_page: 1,
      data: [],
      sellers: [],
      managers: [],
      form: {
        client_search: "",
        seller_id: "",
        manager_id: "",
        search: "",
        since: "",
        until: "",
        user_id: this.props.user.id,
        _seller_id: '',
        order_search: ''
      },
      dates: {
        minDate: "",
        maxDate: ""
      },
      comissions_managers: 0,
      commissions_sellers: 0,
      pagar_managers: 0,
      pagar_sellers: 0,
      modal: {
        paid_amount: '',
        commission_to_pay: '',
      },
      conversion: 0
    };
  }

  abortController = new AbortController();

  componentDidMount() {
    this.load();

    this.getSellers()
    this.getManagers()
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  load = (page = 1) => {
    axios
      .post('web/admin/commissions', {
        web: true,
        user_id: this.props.user.id,
        until: this.state.form.until && moment(this.state.form.until, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        since: this.state.form.since && moment(this.state.form.since, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        currency: this.props.currency,
        page,
        status: [
          Constants.ORDER_STATUS.PENDING,
          Constants.ORDER_STATUS.PROCESSED,
        ],
        seller_id: this.state.form.seller_id,
        _seller_id: this.state.form._seller_id,
        manager_id: this.state.form.manager_id,
        client_search: this.state.form.client_search,
        order_search: this.state.form.order_search
      })
      .then(res => {
        console.log(res)
        this.setState({
          page,
          data: res.data.orders.data,
          //sellers: res.data.sellers,
          //managers: res.data.managers,
          last_page: res.data.orders.last_page,
          comissions_managers: res.data.totales?.managers?.total_commission || 0,
          commissions_sellers: res.data.totales?.sellers?.total_commission || 0,
          pagar_managers: res.data.totales?.managers?.total_pagar || 0,
          pagar_sellers: res.data.totales?.sellers?.total_pagar || 0,
        });
      })
      .catch(err => {
        console.log('Commissions -> load -> catch: ', err);
      });
  };

  getSellers = async () => {
    await axios
      .post('web/admin/orders/sellers', {
        ...this.state.form,
        is_select: true,
        not_admin: true,
      })
      .then(res => {
        this.setState({
          sellers: res.data.sellers,
          conversion: res.data.conversion?.amount || 0
        });
      })
      .catch(err => {
        console.log('Commissions -> getSellers -> catch: ', err);
      });
  };

  getManagers = async () => {
    await axios
      .post('web/admin/orders/managers', {
        ...this.state.form,
      })
      .then(res => {
        this.setState({
          managers: res.data.managers
        });
      })
      .catch(err => {
        console.log('Commissions -> getManagers -> catch: ', err);
      });
  };

  change = async (e) => {
    await this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value
      }
    });
  };

  returnState = async () => {
    await this.setState(state => ({
      ...state,
      search: '',
      form: {
        client_search: "",
        search: "",
        user_id: "",
        seller_id: "",
        manager_id: "",
        _seller_id: '',
        order_search: ''
      },
      thead: [],
      trows: [],
    }));
    await this.load();
  };

  print = () => {
    axios
      .post('web/admin/commissions/download', {
        ...this.state.form,
        user_id: this.props.user.id,
        web: true,
      })
      .then(res => {
        const url = `${ENV.BasePublic}${res.data.url_storage}`;
        const win = window.open(url, "_blank");
        win.focus();
      })
      .catch(err => {
        console.log('Clientes -> download -> catch: ', err);
      });
  }

  togglePaymentModal = () => {
    this.setState(state => ({ visibleAddPayment: !state.visibleAddPayment }));
    this.load()
  };

  render() {
    const { visibleAddPayment } = this.state;

    return (
      <Menu
        history={this.props.history}
        hideContentBreadcumbs
        leftSlot={<HeaderContent onChangeTab={this.props.history.replace} />}
        rightSlot={<HeaderTitle />}
      >
        {this.state.showFilters && (
          <RBModal
            tabIndex="0"
            size="lg"
            show
            onHide={() => this.setState({ showFilters: false })}
            backdropClassName="custom-modal-bd"
            contentClassName="custom-modal-content"
            visible
          >
            <RBModal.Body>
              <img
                src={CloseIcon}
                alt="Cerrar"
                className="close-btn"
                onClick={() => this.setState({ showFilters: false })}
              />

              <Filters
                form={this.state.form}
                sellers={this.state.sellers}
                managers={this.state.managers}
                minDate={this.state.dates.minDate}
                maxDate={this.state.dates.maxDate}
                onSearch={async (filters, close = false) => {
                  await this.setState(s => ({
                    showFilters: close ? false : s.showFilters,
                    page: 1,
                    form: { ...s.form, ...filters }
                  }));
                  this.load();
                }}
                onClose={() => this.setState({ showFilters: false })}
              />
            </RBModal.Body>
          </RBModal>
        )}

        <Modal
          title="Agregar Pago de Comisión"
          onClose={() => this.togglePaymentModal()}
          visible={visibleAddPayment}
        >
          <ModalCreatePayment
            managers={this.state.managers}
            sellers={this.state.sellers}
            onClose={() => this.togglePaymentModal()}
            conversion={this.state.conversion}
          />
        </Modal>

        <div id="commissions" className="new-reports" style={{ marginTop: '2rem' }}>
          <Table
            data={this.state.data.length}
            title={
              <section className="widget-totals inside">
                <div className="widget-total blue">
                  <p className="label">Gerente</p>
                  <p className="amount separated">
                    <span>Total: </span>
                    <span>$ {Globals.formatMiles(this.state.comissions_managers)}</span>
                  </p>
                  <p className="amount separated">
                    <span>Por Pagar: </span>
                    <span>$ {Globals.formatMiles(this.state.pagar_managers)}</span>
                  </p>
                </div>
                <div className="widget-total cyan">
                  <p className="label">Vendedor</p>
                  <p className="amount separated">
                    <span>Total: </span>
                    <span>$ {Globals.formatMiles(this.state.commissions_sellers)}</span>
                  </p>
                  <p className="amount separated">
                    <span>Por Pagar: </span>
                    <span>$ {Globals.formatMiles(this.state.pagar_sellers)}</span>
                  </p>
                </div>
              </section>
            }
            header={this.state.header}
            // right={
            //   <div>
            //     <Button
            //       title="Imprimir"
            //       small="true"
            //       onClick={() => this.print()}
            //     >
            //       <img src={PrinterIcon} style={{ width: 24 }} alt="Imprimir" />
            //     </Button>
            //   </div>
            // }
            right={
              <div>
                <Button
                  title="Filtrar"
                  small="true"
                  onClick={() => this.setState({ showFilters: true })}
                >
                  <img src={FilterIcon} alt="Imprimir" />
                </Button>
                <Button
                  title="Imprimir"
                  small="true"
                  onClick={() => this.print()}
                >
                  <img src={PrinterIcon} style={{ width: 24 }} alt="Imprimir" />
                </Button>
                <Button
                  title="Agregar pago"
                  small="true"
                  onClick={() => this.togglePaymentModal()}
                  disabled={!this.state.sellers.length}
                >
                  <img src={AddIcon} style={{ width: 24 }} alt="Agregar pago" />
                </Button>
              </div>
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
                  <td>{String(i.correlative_number).padStart(4, '0')}</td>
                  <td>{i?.seller?.name}</td>
                  <td>{i.seller?.managers[0]?.name}</td>
                  <td>{i?.client?.name}</td>
                  <td align="right">{Globals.formatMiles(i.total, true)}</td>
                  <td align="right">{Globals.formatMiles(i.partial_payment_total, true)}</td>
                  <td align="right">{Globals.formatMiles(i.total_commission_to_pay.seller, true)}</td>
                  <td align="right">{Globals.formatMiles(i.total_commission_paid_seller)}</td>
                  <td align="right">{Globals.formatMiles(i.total_commission_to_pay.manager, true)}</td>
                  <td align="right">{Globals.formatMiles(i.total_commission_paid_manager)}</td>
                  <td>
                    <Button
                      title="Ver"
                      small="true"
                      color="primary"
                      onClick={() => {
                        this.props.history.push({
                          pathname: '/commissions/payments',
                          state: {
                            order_id: i.id,
                            withoutFilters: true
                          }
                        });
                      }}
                    >
                      <Icon name="eye" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={async page => {
              this.load(page);
            }}
          />
        </div>
      </Menu>
    );
  }
}

const HeaderContent = ({ onChangeTab }) => (
  <>
    <div className="report-sale-tabs">
      <HeaderTab
        icon={TabCommissionIcon}
        label="Comisiones"
        isSelected
        onClick={() => onChangeTab('/commissions')}
      />
      <HeaderTab
        icon={TabCommissionPaymentsIcon}
        label="Pagos"
        onClick={() => onChangeTab('/commissions/payments')}
      />
    </div>
  </>
);

const HeaderTab = ({ icon, isSelected, label, onClick }) => (
  <div className={'report-sale-tab' + (isSelected ? ' active' : '')} onClick={onClick}>
    <img className="no-invert" src={icon} alt={label} />
    <span>{label}</span>
  </div>
);

const HeaderTitle = () => (
  <div className="content-breadcumbs" style={{ display: 'flex', alignItems: 'center' }}>
    <div className="title">Comisiones</div>
  </div>
)

const Filters = ({ form, managers, sellers, minDate, maxDate, onSearch }) => {
  const initialFilters = {
    client_search: '',
    _seller_id: '',
    order_search: '',
    since: '',
    until: '',
  };

  const [_form, setForm] = useState({
    client_search: form.client_search ?? '',
    _seller_id: form._seller_id ?? '',
    order_search: form.order_search ?? '',
    since: !!form.since ? moment(form.since).toDate() : '',
    until: !!form.until ? moment(form.until).toDate() : '',
  });

  const searchTimeout = React.useRef(null);

  React.useEffect(() => {
    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, []);

  const autoFilter = (newForm, isText = false) => {
    if (isText) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
      searchTimeout.current = setTimeout(() => {
        onSearch(newForm, false);
      }, 700);
    } else {
      onSearch(newForm, false);
    }
  };

  const onChange = (value, target, isText = false) => {
    setForm(s => {
      const updated = { ...s, [target]: value };
      autoFilter(updated, isText);
      return updated;
    });
  };

  const reset = () => {
    setForm(initialFilters);
    onSearch(initialFilters, false);
  };

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0 1rem', padding: '1rem 2rem 0' }}>
        <div>
          <Input
            color=" "
            label="Cliente"
            placeholder="Buscar por cliente"
            className="filter"
            value={_form.client_search}
            onChange={e => onChange(e.target.value, 'client_search', true)}
          />
        </div>
        <div>
          <Select
            color="white"
            label="Vendedor/Gerente"
            className="filter"
            defaultname="Todos"
            disabledFirst="false"
            value={_form._seller_id}
            onChange={e => onChange(e.target.value, '_seller_id', false)}
            options={[
              {
                label: 'Vendedores',
                optgroup: true,
                options: sellers.map(i => ({ value: i.id, label: i.name })),
              },
              {
                label: 'Gerentes',
                optgroup: true,
                options: managers.map(i => ({ value: i.id, label: i.name })),
              },
            ]}
          />
        </div>
        <div>
          <Input
            color=" "
            label="ID de pedido"
            className="filter"
            value={_form.order_search}
            onChange={e => onChange(e.target.value, 'order_search', true)}
          />
        </div>
        <div>
          <DatePicker
            color="white"
            label="Desde"
            className="filter"
            minDate={minDate}
            value={_form.since}
            onChange={value => onChange(value, 'since', false)}
          />
        </div>
        <div>
          <DatePicker
            color="white"
            label="Hasta"
            className="filter"
            maxDate={maxDate}
            value={_form.until}
            onChange={value => onChange(value, 'until', false)}
          />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '1rem' }}>
        <Button
          className="btn-align-bottom btn-filter"
          style={{ minWidth: 110, maxWidth: 110, marginRight: 0 }}
          color=" "
          onClick={reset}
        >
          <span>Limpiar</span>
        </Button>
      </div>
    </>
  )
}

export default connect(state => {
  return {
    user: state.user,
    currency: state.currency,
  };
})(Commisions);
